"use strict";
import { getChain } from "constants/chains";
import { supportedChainIdFromGQLChain } from "graphql/data/util";
export function getNativeTokenDBAddress(chain) {
  const pageChainId = supportedChainIdFromGQLChain(chain);
  if (pageChainId === void 0) {
    return void 0;
  }
  return getChain({ chainId: pageChainId }).backendChain.nativeTokenBackendAddress;
}
